import React from "react";

// METEROX brand icon — orange bar chart + blue swoosh inside a frame.
// Frame uses currentColor so it adapts to light/dark themes.
export function LogoIcon({ className = "h-9 w-9" }) {
  return (
    <svg viewBox="0 0 120 120" className={className} role="img" aria-label="METEROX" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="stmk-bar" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FFC531" />
          <stop offset="55%" stopColor="#FB9A0E" />
          <stop offset="100%" stopColor="#F2740A" />
        </linearGradient>
        <linearGradient id="stmk-wave" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#38BDF8" />
          <stop offset="100%" stopColor="#1D4ED8" />
        </linearGradient>
      </defs>
      <rect x="16" y="20" width="88" height="80" rx="3" stroke="currentColor" strokeOpacity="0.45" strokeWidth="3.5" />
      <g fill="url(#stmk-bar)">
        <rect x="26" y="64" width="11" height="30" rx="1.5" />
        <rect x="41" y="48" width="11" height="46" rx="1.5" />
        <rect x="56" y="36" width="11" height="58" rx="1.5" />
        <rect x="71" y="52" width="11" height="42" rx="1.5" />
        <rect x="86" y="60" width="11" height="34" rx="1.5" />
        <rect x="57.5" y="23" width="8" height="8" rx="1" />
      </g>
      <path d="M16 86 C46 71 84 66 105 59 C86 75 48 82 18 87 Z" fill="url(#stmk-wave)" />
    </svg>
  );
}

export default function Logo({ tagline }) {
  return (
    <div className="flex items-center gap-2.5">
      <LogoIcon className="h-9 w-9 shrink-0 text-foreground" />
      <div className="leading-none">
        <div className="font-display text-lg font-black tracking-tight">METEROX</div>
        {tagline ? (
          <div className="label-caps text-muted-foreground hidden sm:block">{tagline}</div>
        ) : null}
      </div>
    </div>
  );
}
